$(document).on('change', '.card_variant_input', function () {
  let ct_var = $(this).val();
  $(this).parents('.ct-product_card_btns').find('.ct-product_card_atc').attr('data-vr-id', ct_var);
});
$(document).on('click', '.ct-product_card_atc', function () {
  let var_id = $(this).data('vr-id');
  if (!var_id) {
    console.log('Variant ID missing');
    return;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [
        {
          id: Number(var_id),
          quantity: 1
        }
      ]
    })
  })
  .then(res => {
    if (!res.ok) throw new Error('ATC failed');
    return res.json();
  })
  .then((data) => {
    console.log('Product added', data);
    if (window.mmajaxcart) {
      mmajaxcart.AjaxcartRender();
      mmajaxcart.AjaxcartOpen();
      mmajaxcart.AjaxcartQuantityHandler();
      mmajaxcart.AjaxcartRemoveItem();
    }
    document.dispatchEvent(
      new CustomEvent('cart:refresh')
    );
    document.querySelector('[href="/cart"]')?.click();
  })
  .catch((err) => {
    console.error('❌ Error:', err);
  });
});

$(document).on('click', '.ct-size-chart', function () {
  $('body').addClass('size-chart-is-open');
});
$(document).on('click', '.ct-size-chart-close', function () {
  $('body').removeClass('size-chart-is-open');
});

$(document).on('click', '.ct-variant_head', function() {
  $(this).toggleClass('active');
  $(this).parents('.ct-product_card_variant_Wrp').find('.ct-product_card_variant').toggleClass('active');
});

if ($('.ct_add_to_cart')) {
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.ct_add_to_cart')) return;
    setTimeout(() => {
      document.querySelector('[href="/cart"]')?.click();
    }, 1500);
  }, true);
}